import { FilterTreeNode, ProviderType } from "@/services/cloudchipr.api";

export const generateResourceDetailsResourceBillingDataPayload = (
  provider: ProviderType,
  identifier: string[],
): FilterTreeNode => ({
  node_type: "group",
  operator: "and",
  items: [
    {
      node_type: "item",
      type: "resource_id",
      filter_provider: provider,
      value: identifier,
      operator: "in",
    },
  ],
});
